import {User} from './../auth/_models/user.model';
import {Store, StoreConfig} from '@datorama/akita';
import {Injectable} from '@angular/core';
import {Appointment} from '@core/models/appointment.model';
import {UserPackage} from '@core/models/user_packages.model';
import {Package} from '@core/models/package.model';
import {Manager} from "@core/models/manager.model";

export interface UserState {
  user: any;

  package: UserPackage;

  doctorPackage: Package;

  merchant: any;

  appointment: Appointment; // geçişlerde kullanılıcak
  data: any;
}

export function createInitialState() {
  const empty = null;
  return {
    user: {
      display_name: null,
      ...empty
    },
    package: null,
    appointment: null,
    // merchant: {
    //   iban: '',
    //   contactName: '',
    //   contactSurname: '',
    // },
  };
}

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'user'})
export class UserStore extends Store<UserState> {
  constructor() {
    super(createInitialState());
  }
}
